/* eslint-disable-line */
$( document ).ready(function()
{
    function areaExist()
    {
        if ($(".availability-area .hld").children().length === 0)
        {
            $(".availability-area").remove();
        }
        if ($(".gmap-area #map_canvas").children().length === 0)
        {
            $(".gmap-area").remove();
        }
    }

    setTimeout(areaExist, 2000);

    function sameHeight()
    {
        const rightSideHeight = $(".more-items").outerHeight() + $(".single-right-box-video").outerHeight();

        const leftSideHeight = $("#item-container").outerHeight();

        if (rightSideHeight > leftSideHeight)
        {
            $("#item-container").css({ "min-height": "calc(" + rightSideHeight + "px - 3rem)" });
        }
    }

    setTimeout(sameHeight, 1000);

    function topOffsetSingle()
    {
        if ($(window).width() > 1199)
        {
            const boxHeight = $(".single-right-box-topbar").outerHeight() + $(".single-right-box-content").outerHeight() + $(".more-items-head").outerHeight() + $(".single-breadcrumbs").outerHeight();

            if ($(".single-right-box-footer").hasClass("d-none"))
            {
                $(".page-singleitem .single-right-box").css({ "top": "calc(-" + boxHeight + "px - 8.5rem)" });
            }
            else
            {
                $(".page-singleitem .single-right-box").css({ "top": "calc(-" + boxHeight + "px - 5.5rem)" });
            }
        }

        $(window).resize(function()
        {
            if ($(window).width() > 1199)
            {
                const boxHeight = $(".single-right-box-topbar").outerHeight() + $(".single-right-box-content").outerHeight() + $(".more-items-head").outerHeight() + $(".single-breadcrumbs").outerHeight();

                if ($(".single-right-box-footer").hasClass("d-none"))
                {
                    $(".page-singleitem .single-right-box").css({ "top": "calc(-" + boxHeight + "px - 8.5rem)" });
                }
                else
                {
                    $(".page-singleitem .single-right-box").css({ "top": "calc(-" + boxHeight + "px - 5.5rem)" });
                }
            }
        });
    }

    setTimeout(topOffsetSingle, 1000);

    // $.ajax({
    //     type: "GET",
    //     url: "https://sales.reiseschein.de/holidaycheck/prx_hotel.php?id="+weightNetG,
    //     cache: false,
    //     dataType: "xml",
    //     success: function(xml)
    //     {
    //         const countReviews = parseFloat($(xml).find("countReviews").text()).toFixed(0);
    //
    //         const recommendation = parseFloat($(xml).find("recommendation").text()).toFixed(0);
    //
    //         const averageRating = parseFloat($(xml).find("averageRating").text()).toFixed(1);
    //
    //         $("#countReviews").text(countReviews);
    //
    //         $("#recommendation").text(recommendation);
    //         $(".scale.recommendation::before").css({ width : recommendation + "%" });
    //         $("head").append("<style>.scale.recommendation::before{width:" + recommendation + "%" + "}</style>");
    //
    //         $("#averageRating").text(averageRating);
    //         $("head").append("<style>.scale.averageRating::before{width:" + averageRating / 6 * 100 + "%" + "}</style>");
    //     }
    // });
    //
    // // rating
    // $.ajax({
    //     type: "GET",
    //     url: "https://sales.reiseschein.de/holidaycheck/prx_rating.php?id=" + weightNetG,
    //     cache: false,
    //     dataType: "xml",
    //     success: function(xml)
    //     {
    //         const hotelRating = parseFloat($(xml).find("hotelRating").find("overall").text()).toFixed(1);
    //
    //         $("#hotelRating").text(hotelRating);
    //         $("head").append("<style>#hotelRatingRate::before{width:" + hotelRating / 6 * 100 + "%" + "}</style>");
    //
    //         const roomRating = parseFloat($(xml).find("roomRating").find("overall").text()).toFixed(1);
    //
    //         $("#roomRating").text(roomRating);
    //         $("head").append("<style>#roomRatingRate::before{width:" + roomRating / 6 * 100 + "%" + "}</style>");
    //
    //         const serviceRating = parseFloat($(xml).find("serviceRating").find("overall").text()).toFixed(1);
    //
    //         $("#serviceRating").text(serviceRating);
    //         $("head").append("<style>#serviceRatingRate::before{width:" + serviceRating / 6 * 100 + "%" + "}</style>");
    //
    //         const locationRating = parseFloat($(xml).find("locationRating").find("overall").text()).toFixed(1);
    //
    //         $("#locationRating").text(locationRating);
    //         $("head").append("<style>#locationRatingRate::before{width:" + locationRating / 6 * 100 + "%" + "}</style>");
    //
    //         const foodRating = parseFloat($(xml).find("foodRating").find("overall").text()).toFixed(1);
    //
    //         $("#foodRating").text(foodRating);
    //         $("head").append("<style>#foodRatingRate::before{width:" + foodRating / 6 * 100 + "%" + "}</style>");
    //
    //         const sportRating = parseFloat($(xml).find("sportRating").find("overall").text()).toFixed(1);
    //
    //         $("#sportRating").text(sportRating);
    //         $("head").append("<style>#sportRatingRate::before{width:" + sportRating / 6 * 100 + "%" + "}</style>");
    //
    //         const hotelId = $(xml).find("hotelId").text();
    //
    //         $(".go-rate").attr("href", "https://review.holidaycheck.com/?q=de/review/reiseschein/" + hotelId +"&utm_source=b2b&utm_medium=kooperation&utm_campaign=Reiseschein");
    //     }
    // });

    $(document).on("keyup", ".startort-txt", function(event)
    {
        const keycode = (event.keyCode ? event.keyCode : event.which);

        if (keycode == "13")
        {
            $(".find-route").click();
        }
    });
});

$( document ).ready(function()
{
    let addressData;

    let map;

    let mapIsLoaded = false;
    // eslint-disable-next-line no-unused-vars

    const infoWindowArray = [];
    // eslint-disable-next-line no-unused-vars

    const directionsService = new google.maps.DirectionsService();

    let zielAdresse;
    // eslint-disable-next-line no-unused-vars

    producerName = producerName.replace( /&/g, "&amp;" ).replace( /</g, "&lt;" ).replace( />/g, "&gt;" );

    function initializeGoogleMaps()
    {

        const geocoder = new google.maps.Geocoder();

        let fixedAddressData = addressData;

        const listAddressData = addressData.split( "\n" );

        if ( listAddressData.length >= 3 )
        {
            listAddressData.shift();
            fixedAddressData = listAddressData.join( " " );
        }

        geocoder.geocode( {
            address: fixedAddressData
        }, function( locResult, status )
        {
            if ( status != google.maps.GeocoderStatus.OK || locResult.length === 0 )
            {
                console.warn( "Fehler: " + status + " - bei: " + fixedAddressData );
                return;
            }

            const lat1 = locResult[0].geometry.location.lat();

            const lng1 = locResult[0].geometry.location.lng();

            const directionsDisplay = new google.maps.DirectionsRenderer();

            const latlng = new google.maps.LatLng( lat1, lng1 );

            zielAdresse = latlng;
            const mapOptions = {
                center: latlng,
                zoom: 14,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: true,
                scrollwheel: false
            };

            map = new google.maps.Map( document.getElementById( "map_canvas" ), mapOptions );
            createMarker( latlng, "https://reiseschein.com/icons/multi-marker.svg", markerName1, $( ".hotelAddressData" ).html(), true, manufacturerLogo, null );
            directionsDisplay.setMap( map );
            directionsDisplay.setPanel( document.getElementById( "directionsPanel" ) );
        } );
    }

    // eslint-disable-next-line no-unused-vars
    function callback( results, status )
    {
        if ( status == google.maps.places.PlacesServiceStatus.OK )
        {
            for ( let i = 0; i < results.length; i++ )
            {
                // eslint-disable-next-line no-unused-vars
                const place = results[i];

                let placePhoto = null;

                // eslint-disable-next-line
                if ( results[i].photos !== undefined )
                {
                    placePhoto = results[i].photos[0].getUrl( {
                        "maxWidth": 150,
                        "maxHeight": 150
                    } );
                }
                createMarker( results[i].geometry.location, results[i].icon, results[i].name, results[i].vicinity, false, results[i].icon, results[i].types, placePhoto );
            }
        }
    }

    function createMarker( latlng, markerImageUrl, markerName, markerStreet, needOpen, logoUrl, locationType, placePhoto )
    {
        let placeLogo = null;

        if ( placePhoto !== null )
        {
            placeLogo = placePhoto;
        }
        else
        {
            placeLogo = logoUrl;
        }

        const contentString = createInfoWindow( markerName, markerStreet, placeLogo );

        const infowindow = new google.maps.InfoWindow( {
            content: contentString,
            disableAutoPan: true,
            positionMiddleOfWindow: true
        } );

        infoWindowArray.push( infowindow );

        google.maps.event.addListener( infowindow, "domready", function()
        {
            map.panBy( 0, -40 );
        } );

        // Image Marker
        const pinIcon = new google.maps.MarkerImage(
            markerImageUrl,
            null,
            null,
            null,
            new google.maps.Size( 60, 60 )
        );

        const marker = new google.maps.Marker( {
            position: latlng,
            map: map,
            title: "",
            animation: google.maps.Animation.DROP,
            icon: pinIcon
        } );

        marker.setMap( map );
        if ( needOpen )
        {
            infowindow.open( map, marker );
        }
        else
        {
            createOverview( markerName, markerImageUrl, "", marker, infoWindowArray[infoWindowArray.length - 1], locationType );
        }
        google.maps.event.addListener( marker, "click", function()
        {
            resetInfoWindow();
            infowindow.open( map, marker );
        } );
    }

    function resetInfoWindow()
    {
        if ( infoWindowArray )
        {
            for ( const i in infoWindowArray )
            {
                infoWindowArray[i].close();
            }
        }
    }

    function createOverview( typeName, imgUrl, type, markerTmp, infowindowTmp, locationType )
    {
        const ovDiv = $( "<div />" );

        const ovImg = $( "<img />" );

        const ovName = $( "<p />" );

        $( ovDiv ).bind( "click", {
            pinfowindow: infowindowTmp,
            pMarker: markerTmp
        }, function( event )
        {
            $( ".active-standort" ).removeClass( "active-standort" );
            $( this ).addClass( "active-standort" );
            resetInfoWindow();
            event.data.pinfowindow.open( map, event.data.pMarker );
        } );
        $( ovImg ).attr( "src", imgUrl );
        $( ovImg ).addClass( "google-overview-img" );
        $( ovName ).addClass( "google-overview-name" );
        $( ovName ).text( typeName );
        $( ovDiv ).append( ovImg );
        $( ovDiv ).append( ovName );
        let isEsta = false;

        let isFood = false;

        $( locationType ).each( function( data, key )
        {
            if ( key == "establishment" && !isFood )
            {
                isEsta = true;
            }
            if ( key == "restaurant" || key == "cafe" || key == "food" || key == "bar" )
            {
                isEsta = false;
                isFood = true;
            }
        } );
        if ( isEsta )
        {
            $( ".google-tab2-content" ).append( ovDiv );
        }
        else
        {
            $( ".google-tab1-content" ).append( ovDiv );
        }
    }

    function createInfoWindow( markerName, markerStreet, placeLogo )
    {
        const tmpDiv = $( "<div />" );

        const contenDiv = $( "<div />" );

        $( contenDiv ).addClass( "content-google-map" );
        const headText = $( "<div />" );

        $( headText ).addClass( "firstHeading" );
        $( headText ).html( markerName );

        if (manufacturerLogo != "")
        {
            var logoDiv = $( "<div />" );

            $( logoDiv ).addClass( "siteNotice" );
            $( logoDiv ).html( "<img src=\""+ manufacturerLogo +"\" alt=\"" + producerName + "\" title=\"" + producerName + "\" />" );
        }


        const bodyContent = $( "<div />" );

        $( bodyContent ).addClass( "bodyContent" );
        $( bodyContent ).html( markerStreet );
        $( headText ).html( markerName );
        $( contenDiv ).append( headText );
        $( contenDiv ).append( logoDiv );
        $( contenDiv ).append( bodyContent );
        $( tmpDiv ).append( contenDiv );
        return $( tmpDiv ).html();
    }

    function calcRoute( start )
    {
        const request =
            {
                origin: start,
                destination: zielAdresse,
                travelMode: google.maps.DirectionsTravelMode.DRIVING
            };

        directionsService.route( request, function( response, status )
        {
            if ( status == google.maps.DirectionsStatus.OK )
            {
                directionsDisplay.setDirections( response );
            }
            let routeStatus = true;

            if ( status === "ZERO_RESULTS" )
            {
                alert( "Keine Route gefunden." );
                routeStatus = false;
            }
            else if ( status === "UNKNOWN_ERROR" )
            {
                alert( "Ein Serverfehler ist aufgetreten." );
                routeStatus = false;
            }
            else if ( status === "OVER_QUERY_LIMIT" )
            {
                alert( "Zuviele Anfragen, bitte versuchen Sie es später erneut." );
                routeStatus = false;
            }
            else if ( status === "NOT_FOUND" )
            {
                alert("Die Zieladresse gibt es nicht oder konnte nicht ermittelt werden.");
                routeStatus = false;
            }
            else if ( status === "INVALID_REQUEST" )
            {
                alert("Die Zieladresse gibt es nicht oder konnte nicht ermittelt werden.");
                routeStatus = false;
            }
            if ( routeStatus )
            {
                $( ".show-route-information" ).show();
            }
            else
            {
                $( ".show-route-information" ).hide();
            }
        } );
    }

    $( ".show-route-information" ).click( function()
    {
        $( "#directionsPanel" ).toggle( "fade" );
    } );

    $( ".find-route" ).click( function()
    {
        console.log("click");
        if ( $( ".startort-txt" ).val().length !== 0 )
        {
            const geocoder = new google.maps.Geocoder();

            geocoder.geocode( {
                address: $( ".startort-txt" ).val()
            }, function( locResult )
            {
                if ( locResult.length > 0 )
                {
                    const lat1 = locResult[0].geometry.location.lat();

                    const lng1 = locResult[0].geometry.location.lng();

                    const latlng = new google.maps.LatLng( lat1, lng1 );

                    calcRoute( latlng );
                }
                else
                {
                    alert( "Startort wurde nicht gefunden" );
                }
            } );
        }
    } );

    addressData = $.trim($(".hotel-address").html());

    if (!mapIsLoaded)
    {
        initializeGoogleMaps();
        mapIsLoaded = true;
    }
    /* GOOGLE MAPS END */
});
/* eslint-disable-line */
